export const MARKETING_EMAIL_RESET_STATE = 'MARKETING_EMAIL_RESET_STATE';
export const MARKETING_EMAIL_CURRENT_ITEM = 'MARKETING_EMAIL_CURRENT_ITEM';

export const MARKETING_EMAIL_REQUEST_LOADING = 'MARKETING_EMAIL_REQUEST_LOADING';
export const MARKETING_EMAIL_REQUEST_SUCCESS = 'MARKETING_EMAIL_REQUEST_SUCCESS';
export const MARKETING_EMAIL_REQUEST_FAILED = 'MARKETING_EMAIL_REQUEST_FAILED';

export const MARKETING_EMAIL_CURRENT_ACTION = 'MARKETING_EMAIL_CURRENT_ACTION';
export const MARKETING_EMAIL_RESET_ACTION = 'MARKETING_EMAIL_RESET_ACTION';
